import React from 'react';
import OTPInput from 'react-otp-input';
import { useWindowSize } from '../../Hooks/useWindowSize';

const VerifyOtp = ({
  userInput,
  otp,
  setOtp,
  formattedSeconds,
  counter,
  resend_email,
  isLoading,
  otpErr,
  handleOtpChange,
}) => {
  const { width: windowWidth } = useWindowSize();
  const isMobileView = windowWidth <= 450;
  const isMobileSM = windowWidth <= 380;
  return (
    <>
      <p className="text-textSmall font-DMSansFont font-normal text-LightTextParagraph text-center">
        Enter the verification code we sent to{' '}
        <span className="font-bold">{userInput.email}</span>
      </p>

      <div>
        <OTPInput
          value={otp}
          onChange={(e) => handleOtpChange(e)}
          numInputs={6}
          renderSeparator={<span> </span>}
          inputStyle={{
            width: isMobileView ? '38px' : '54px',
            height: isMobileView ? '38px' : '54px',
            margin: isMobileSM ? '0px 3px' : '0px 7px',
            fontSize: isMobileView ? '20px' : '26px',
            fontWeight: 700,
            textAlign: 'center',
            background: '#F3F4F8',
            borderRadius: '6px',
            color: '#19224C',
            outline: 'none',
            fontFamily: 'DM Sans,sans-serif',
          }}
          containerStyle={{
            justifyContent: 'space-between',
            width: '100%',
          }}
          renderInput={(props) => <input {...props} />}
        />
      </div>

      <div className="mt-[6px] flex flex-col items-center">
        {otpErr && (
          <p className="smallText16 text-[#ff0000] max_sm:text-[14px] ml-[2px] max_sm:ml-0 mt-[1px]">
            Please enter a valid OTP
          </p>
        )}
        <div
          className={`min-h-[28px] text-textMedium font-DMSansFont font-normal text-ButtonPrimary text-center leading-[23px] ${
            counter === 0 ? 'hidden' : ''
          }`}
        >
          <span style={{ display: 'inline-block' }}>00:</span>
          <span style={{ display: 'inline-block' }}>
            {formattedSeconds}
          </span>{' '}
        </div>

        <p className="text-center mt-4 text-LightSecondary text-textSmall font-DMSansFont font-medium">
          Didn't receive an email?
        </p>

        <p
          className={`mt-3 text-textSmall font-DMSansFont font-medium px-4 py-[5px] text-center ${
            counter > 0
              ? 'text-DisableText cursor-not-allowed'
              : 'text-ButtonPrimary cursor-pointer'
          }`}
          onClick={() => {
            if (counter === 0 && !isLoading) {
              resend_email();
            }
          }}
        >
          Resend email
        </p>
      </div>
    </>
  );
};

export default VerifyOtp;
